export const subscriptionPlans = {
  free: {
    type: "free",
    title: "Free Tier",
    subtitle: "Discover",
    description: "Get your AI job risk score and sample career paths for free",
    price: "$0",
    period: "",
    color: "gray",
    popular: false,
    buttonText: "Sign Up Free",
    tag: null,
    features: [
      {
        category: "Career Assessments",
        items: [
          { value: "true", text: "AI Job Impact Score" },
          { value: "true", text: "AI Literacy Quiz" }
        ]
      },
      {
        category: "Career Discovery",
        items: [
          { value: "true", text: "Basic Career Recommendation" },
          { value: "false", text: "Detailed Career Recommendations" },
          { value: "false", text: "Career Simulation" }
        ]
      },
      {
        category: "Skills & Learning",
        items: [
          { value: "false", text: "Skills Gap Analysis Tool" },
          { value: "false", text: "Learning Path (Courses, Skills, AI Tools)" },
          { value: "false", text: "Smart Learning Helper" }
        ]
      },
      {
        category: "Mentors and Community",
        items: [
          { value: "1 Learning or Industry Group", text: "Community Access" },
          { value: "Pay Per Session - Full Price", text: "Mentors" }
        ]
      },
      {
        category: "AI ChatBot Support",
        items: [
          { value: "false", text: "Career Genie Chatbot" }
        ]
      },
      {
        category: "Job Search Support",
        items: [
          { value: "false", text: "Access to Jobs" },
          { value: "false", text: "Access To AI Talent Pool" },
          { value: "Pay Per Session", text: "Mock Interview Practice" }
        ]
      }
    ],
    showMoreFeatures: "Show More Features (10 more)"
  },
  trial: {
    type: "onetime",
    title: "3-Day All-Access Pass",
    subtitle: "Try All the Key Features",
    description: "Get your career clarity in 3 days with full access to all premium features",
    price: "$19.99",
    period: "One-time payment",
    color: "purple",
    popular: false,
    buttonText: "Start 3-Day Trial",
    tag: "Limited Time",
    features: [
      {
        category: "Career Assessments",
        items: [
          { value: "true", text: "AI Job Impact Score" },
          { value: "true", text: "AI Literacy Quiz" }
        ]
      },
      {
        category: "Career Discovery",
        items: [
          { value: "true", text: "Basic Career Recommendation" },
          { value: "true", text: "Detailed Career Recommendations" },
          { value: "true", text: "Career Simulation", note: "Unlimited for 3 days" }
        ]
      },
      {
        category: "Skills & Learning",
        items: [
          { value: "true", text: "Skills Gap Analysis Tool" },
          { value: "true", text: "Learning Path (Courses, Skills, AI Tools)" },
          { value: "false", text: "Smart Learning Helper" }
        ]
      },
      {
        category: "Mentors and Community",
        items: [
          { value: "Unlimited for 3 days", text: "Community Access" },
          { value: "Pay Per Session - Full Price", text: "Mentors" }
        ]
      },
      {
        category: "AI ChatBot Support",
        items: [
          { value: "Full access for 3 days", text: "Career Genie Chatbot" }
        ]
      },
      {
        category: "Job Search Support",
        items: [
          { value: "true", text: "Access to Jobs" },
          { value: "false", text: "Access To AI Talent Pool" },
          { value: "Pay Per Session", text: "Mock Interview Practice" }
        ]
      }
    ],
    showMoreFeatures: "Show More Features (7 more)"
  },
  pro: {
    monthly: {
      type: "pro-monthly",
      price: "$24.99",
      period: "/Month or $249/year (2 months Free)",
    },
    yearly: {
      type: "pro-yearly",
      price: "$249.00",
      period: "/Year (2 months Free)",
    },
    title: "Pro Tier",
    subtitle: "Accelerate",
    description: "Unlock AI career insights with career simulation capabilities",
    color: "purple",
    popular: true,
    buttonText: "Upgrade Now",
    tag: "Most Popular",
    features: [
      {
        category: "Career Assessments",
        items: [
          { value: "true", text: "AI Job Impact Score" },
          { value: "true", text: "AI Literacy Quiz" }
        ]
      },
      {
        category: "Career Discovery",
        items: [
          { value: "true", text: "Basic Career Recommendation" },
          { value: "true", text: "Detailed Career Recommendations" },
          { value: "true", text: "Career Simulation", note: "1 simulation per month" }
        ]
      },
      {
        category: "Skills & Learning",
        items: [
          { value: "true", text: "Skills Gap Analysis Tool" },
          { value: "true", text: "Learning Path (Courses, Skills, AI Tools)" },
          { value: "false", text: "Smart Learning Helper" }
        ]
      },
      {
        category: "Mentors and Community",
        items: [
          { value: "Unlimited Access", text: "Community Access" },
          { value: "Pay Per Session - 5% Discount", text: "Mentors" }
        ]
      },
      {
        category: "AI ChatBot Support",
        items: [
          { value: "true", text: "Career Genie Chatbot" }
        ]
      },
      {
        category: "Job Search Support",
        items: [
          { value: "true", text: "Access to Jobs" },
          { value: "true", text: "Access To AI Talent Pool" },
          { value: "2 sessions per month", text: "Mock Interview Practice" }
        ]
      }
    ],
    showMoreFeatures: "Show More Features (10 more)"
  },
};
